import {createAction} from '@reduxjs/toolkit'

/**
 * Embedding context only React can resolve is synced into the store so
 * selectors can compose it without params.
 */
export const setIsEmbeddedWithKiwi = createAction<boolean>(
  'common/setIsEmbeddedWithKiwi'
)

export type ActionType = ReturnType<typeof setIsEmbeddedWithKiwi>
